import {EncodingSelect} from "./EncodingSelect.jsx";
import React, { useState } from "react";
import { convert } from "./converter.js";
import { useApp, useTranslate, TypingInput } from "./common.jsx";
import { EncodingKeyboard } from "./EncodingKeyboard.jsx";
export function Converter() {
  const a = useApp(),
    t = useTranslate();
  const [input, setInput] = useState("gamarjoba, saqarTvelo!"),
    [from, setFrom] = useState("_eng_"),
    [to, setTo] = useState("_utf8_"),
    [layout] = useState("unchanged");
  const output = convert(input, from, to, layout);
  return (
    <main className="wide">
      <div className="titleline">
        <div>
          <p className="eyebrow">{t("GEORGIAN TEXT, CONNECTED")}</p>
          <h1>
            {t("Same words. A new format.", "იგივე სიტყვები. ახალი ფორმატი.")}
          </h1>
          <p>
            {t(
              "Convert Georgian text between Unicode and legacy encodings.",
              "გარდაქმენით ქართული ტექსტი Unicode-სა და ძველ კოდირებებს შორის.",
            )}
          </p>
        </div>
        <span className="stamp">ა</span>
      </div>
      <div className="quickpairs">
        {[
          ["_eng_", "_utf8_", "Latin → Unicode"],
          ["_standart_", "_utf8_", "STD8 → Unicode"],
          ["latin-russian", "_utf8_", "ЙЦУКЕН → Unicode"],
          ["latin-typewriter", "_utf8_", "ღჯუკენ → Unicode"],
        ].map(([f, v, l]) => (
          <button
            key={l}
            data-pair={f + "|" + v}
            onClick={() => {
              setFrom(f);
              setTo(v);
            }}
          >
            {l}
          </button>
        ))}
      </div>
      <div className="converter">
        {[false, true].map((result) => (
          <section className="textpanel" key={String(result)}>
            <div className="panelhead">
              <label>{t(result ? "To" : "From")}</label>
              <EncodingSelect id={result ? "to" : "from"} value={result ? to : from} onChange={result ? setTo : setFrom}/>

            </div>
            {result ? (
              <textarea
                id="convertoutput"
                readOnly
                value={output}
                aria-label="Converted text"
              />
            ) : (
              <TypingInput
                id="convertinput"
                multiline
                value={input}
                onChange={setInput}
                aria-label="Text to convert"
              />
            )}
            <div className="panelfoot">
              <span>
                {[...(result ? output : input)].length} {t("characters")}
              </span>
              <button
                onClick={() =>
                  document
                    .getElementById(result ? "convertoutput" : "convertinput")
                    .select()
                }
              >
                {t("Select all")}
              </button>
            </div>
          </section>
        ))}
      </div>
      <div className="converteractions">
        <div>
          <button
            className="secondary"
            data-action="swap"
            onClick={() => {
              setFrom(to);
              setTo(from);
              setInput(output);
            }}
          >
            {t("Swap")}
          </button>
          <button
            className="secondary"
            data-action="clearinput"
            onClick={() => setInput("")}
          >
            {t("Clear")}
          </button>

        </div>
        <div>
          <button
            className="primary"
            data-action="copyoutput"
            onClick={() => a.copy(output)}
          >
            {t("Copy result")}
          </button>
          <button
            className="secondary"
            onClick={() => {
              const url = URL.createObjectURL(
                new Blob([output], { type: "text/plain;charset=utf-8" }),
              );
              const link = document.createElement("a");
              link.href = url;
              link.download = "fontlab-text.txt";
              link.click();
              setTimeout(() => URL.revokeObjectURL(url), 1000);
            }}
          >
            {t("Download text")}
          </button>
        </div>
      </div>
      <EncodingKeyboard from={from} to={to} input={input} onInput={setInput} />
      <p className="note">
        {t(
          "Text is converted in your browser. Check a short sample before converting a document.",
          "ტექსტი თქვენს ბრაუზერში მუშავდება. დოკუმენტამდე შეამოწმეთ მოკლე ნიმუში.",
        )}{" "}
        <a
          href="https://convert.ge/ge/text.shtml"
          target="_blank"
          rel="noopener"
        >
          convert.ge
        </a>{" "}
        · Mapping data: CC BY-NC-ND 2.0
      </p>
    </main>
  );
}
